export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  GDS__Any: { input: unknown; output: unknown; }
  GDS__FieldSet: { input: unknown; output: unknown; }
  WWS_Date: { input: unknown; output: unknown; }
  WWS_Json: { input: unknown; output: unknown; }
};

export enum DatePreference {
  Exact = 'Exact',
  None = 'None',
  Range = 'Range',
  Season = 'Season',
  Tba = 'TBA'
}

export interface Gds_Address {
  readonly __typename?: 'GDS_Address';
  readonly city?: Maybe<Scalars['String']['output']>;
  readonly country?: Maybe<Scalars['String']['output']>;
  readonly fullAddress?: Maybe<Scalars['String']['output']>;
  readonly state?: Maybe<Scalars['String']['output']>;
  readonly street1?: Maybe<Scalars['String']['output']>;
  readonly street2?: Maybe<Scalars['String']['output']>;
  readonly zip?: Maybe<Scalars['String']['output']>;
}

export interface Gds_Answer {
  readonly __typename?: 'GDS_Answer';
  readonly optionId?: Maybe<Scalars['String']['output']>;
  readonly questionId: Scalars['String']['output'];
  readonly text?: Maybe<Scalars['String']['output']>;
}

export interface Gds_AnswerData {
  readonly __typename?: 'GDS_AnswerData';
  readonly optionId?: Maybe<Scalars['String']['output']>;
  readonly responseCount?: Maybe<Scalars['Int']['output']>;
  readonly responses?: Maybe<ReadonlyArray<Maybe<Gds_Responder>>>;
  readonly text: Scalars['String']['output'];
}

export interface Gds_CreateAddressInput {
  readonly city?: InputMaybe<Scalars['String']['input']>;
  readonly country?: InputMaybe<Scalars['String']['input']>;
  readonly fullAddress?: InputMaybe<Scalars['String']['input']>;
  readonly state?: InputMaybe<Scalars['String']['input']>;
  readonly street1?: InputMaybe<Scalars['String']['input']>;
  readonly street2?: InputMaybe<Scalars['String']['input']>;
  readonly zip?: InputMaybe<Scalars['String']['input']>;
}

export interface Gds_CreateAnswerInput {
  readonly optionId?: InputMaybe<Scalars['String']['input']>;
  readonly questionId: Scalars['String']['input'];
  readonly text?: InputMaybe<Scalars['String']['input']>;
}

export interface Gds_CreateHouseholdInput {
  readonly address?: InputMaybe<Gds_CreateAddressInput>;
  readonly answers?: InputMaybe<ReadonlyArray<Gds_CreateAnswerInput>>;
  readonly coupleNote?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly groupId?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly people: ReadonlyArray<Gds_CreatePersonInput>;
  readonly rsvpNote?: InputMaybe<Scalars['String']['input']>;
  readonly weddingId: Scalars['String']['input'];
}

export interface Gds_CreateInvitationInput {
  readonly answers?: InputMaybe<ReadonlyArray<Gds_CreateAnswerInput>>;
  readonly eventId: Scalars['String']['input'];
  readonly gift?: InputMaybe<Scalars['String']['input']>;
  readonly invitationSent?: InputMaybe<Scalars['Boolean']['input']>;
  readonly meal?: InputMaybe<Scalars['String']['input']>;
  readonly rsvp?: InputMaybe<Scalars['Boolean']['input']>;
  readonly thankYouSent?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface Gds_CreatePersonInput {
  readonly answers?: InputMaybe<ReadonlyArray<Gds_CreateAnswerInput>>;
  readonly email?: InputMaybe<Scalars['String']['input']>;
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  readonly invitations: ReadonlyArray<Gds_CreateInvitationInput>;
  readonly isLeader?: InputMaybe<Scalars['Boolean']['input']>;
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  readonly phone?: InputMaybe<Scalars['String']['input']>;
}

export interface Gds_DeleteInvitationInput {
  readonly householdId: Scalars['String']['input'];
  readonly id: Scalars['String']['input'];
  readonly personId: Scalars['String']['input'];
}

export interface Gds_DeleteInvitationPayload {
  readonly __typename?: 'GDS_DeleteInvitationPayload';
  readonly id?: Maybe<Scalars['String']['output']>;
}

export interface Gds_Event {
  readonly __typename?: 'GDS_Event';
  readonly attire?: Maybe<Scalars['String']['output']>;
  readonly createdAt: Scalars['String']['output'];
  readonly date?: Maybe<Scalars['String']['output']>;
  readonly endTime?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['String']['output'];
  readonly image?: Maybe<Gds_Image>;
  readonly location?: Maybe<Gds_Location>;
  readonly meals?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly notes?: Maybe<Scalars['String']['output']>;
  readonly order?: Maybe<Scalars['Int']['output']>;
  readonly questions?: Maybe<ReadonlyArray<Gds_Question>>;
  readonly requireRsvp?: Maybe<Scalars['Boolean']['output']>;
  readonly sameVenue?: Maybe<Scalars['Boolean']['output']>;
  readonly subEvents?: Maybe<ReadonlyArray<Gds_SubEvent>>;
  readonly time?: Maybe<Scalars['String']['output']>;
  readonly type?: Maybe<Scalars['String']['output']>;
  readonly updatedAt: Scalars['String']['output'];
  readonly visible?: Maybe<Scalars['Boolean']['output']>;
  readonly weddingId: Scalars['String']['output'];
}

export interface Gds_EventQuestionResponseData {
  readonly __typename?: 'GDS_EventQuestionResponseData';
  readonly eventId: Scalars['String']['output'];
  readonly eventName: Scalars['String']['output'];
  readonly questionsData?: Maybe<ReadonlyArray<Maybe<Gds_QuestionResponseData>>>;
}

export interface Gds_EventRsvpData {
  readonly __typename?: 'GDS_EventRsvpData';
  readonly acceptCount?: Maybe<Scalars['Int']['output']>;
  readonly eventId: Scalars['String']['output'];
  readonly guestCount?: Maybe<Scalars['Int']['output']>;
  readonly rejectCount?: Maybe<Scalars['Int']['output']>;
}

export interface Gds_Group {
  readonly __typename?: 'GDS_Group';
  readonly createdAt: Scalars['String']['output'];
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly emoji?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['String']['output'];
  readonly updatedAt: Scalars['String']['output'];
  readonly weddingId: Scalars['String']['output'];
}

export interface Gds_GuestWedding {
  readonly __typename?: 'GDS_GuestWedding';
  readonly allowGuestPreview?: Maybe<Scalars['Boolean']['output']>;
  readonly createdAt: Scalars['String']['output'];
  readonly id: Scalars['String']['output'];
  readonly isPrivateRsvp?: Maybe<Scalars['Boolean']['output']>;
  readonly questions?: Maybe<ReadonlyArray<Gds_Question>>;
  readonly rsvpAsAPage?: Maybe<Scalars['Boolean']['output']>;
  readonly rsvpDeadline?: Maybe<Scalars['String']['output']>;
  readonly rsvpMedium?: Maybe<Scalars['String']['output']>;
  readonly rsvpPageHidden?: Maybe<Scalars['Boolean']['output']>;
  readonly rsvpWorkflow?: Maybe<Scalars['Boolean']['output']>;
  readonly sendRsvpReminder?: Maybe<Scalars['Boolean']['output']>;
  readonly updatedAt: Scalars['String']['output'];
  readonly usesQuestions?: Maybe<Scalars['Boolean']['output']>;
  readonly usesSubEvents?: Maybe<Scalars['Boolean']['output']>;
}

export interface Gds_GuestWeddingQuestionResponseData {
  readonly __typename?: 'GDS_GuestWeddingQuestionResponseData';
  readonly guestWeddingId: Scalars['String']['output'];
  readonly questionsData?: Maybe<ReadonlyArray<Maybe<Gds_QuestionResponseData>>>;
}

export interface Gds_Household {
  readonly __typename?: 'GDS_Household';
  readonly address?: Maybe<Gds_Address>;
  readonly answers?: Maybe<ReadonlyArray<Gds_Answer>>;
  readonly coupleNote?: Maybe<Scalars['String']['output']>;
  readonly createdAt: Scalars['String']['output'];
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly groupId?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['String']['output'];
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly people: ReadonlyArray<Gds_Person>;
  readonly rsvpNote?: Maybe<Scalars['String']['output']>;
  readonly updatedAt: Scalars['String']['output'];
  readonly weddingId: Scalars['String']['output'];
}

export interface Gds_Image {
  readonly __typename?: 'GDS_Image';
  readonly createdAt: Scalars['String']['output'];
  readonly cropBox?: Maybe<Scalars['String']['output']>;
  readonly height?: Maybe<Scalars['Int']['output']>;
  readonly id: Scalars['String']['output'];
  readonly rotationAngle?: Maybe<Scalars['Int']['output']>;
  readonly updatedAt: Scalars['String']['output'];
  readonly width?: Maybe<Scalars['Int']['output']>;
}

export interface Gds_Invitation {
  readonly __typename?: 'GDS_Invitation';
  readonly answers?: Maybe<ReadonlyArray<Gds_Answer>>;
  readonly createdAt: Scalars['String']['output'];
  readonly eventId: Scalars['String']['output'];
  readonly gift?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['String']['output'];
  readonly invitationSent?: Maybe<Scalars['Boolean']['output']>;
  readonly meal?: Maybe<Scalars['String']['output']>;
  readonly rsvp?: Maybe<Scalars['Boolean']['output']>;
  readonly thankYouSent?: Maybe<Scalars['Boolean']['output']>;
  readonly updatedAt: Scalars['String']['output'];
}

export interface Gds_Location {
  readonly __typename?: 'GDS_Location';
  readonly city?: Maybe<Scalars['String']['output']>;
  readonly country?: Maybe<Scalars['String']['output']>;
  readonly fullAddress?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly state?: Maybe<Scalars['String']['output']>;
  readonly street1?: Maybe<Scalars['String']['output']>;
  readonly street2?: Maybe<Scalars['String']['output']>;
  readonly zip?: Maybe<Scalars['String']['output']>;
}

export interface Gds_Option {
  readonly __typename?: 'GDS_Option';
  readonly createdAt: Scalars['String']['output'];
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['String']['output'];
  readonly text?: Maybe<Scalars['String']['output']>;
  readonly updatedAt: Scalars['String']['output'];
}

export interface Gds_Person {
  readonly __typename?: 'GDS_Person';
  readonly answers?: Maybe<ReadonlyArray<Gds_Answer>>;
  readonly createdAt: Scalars['String']['output'];
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly firstName?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['String']['output'];
  readonly invitations: ReadonlyArray<Gds_Invitation>;
  readonly isLeader?: Maybe<Scalars['Boolean']['output']>;
  readonly lastName?: Maybe<Scalars['String']['output']>;
  readonly phone?: Maybe<Scalars['String']['output']>;
  readonly preferences?: Maybe<Gds_Preferences>;
  readonly updatedAt: Scalars['String']['output'];
}

export interface Gds_Preferences {
  readonly __typename?: 'GDS_Preferences';
  readonly emailOptOut?: Maybe<Scalars['Boolean']['output']>;
  readonly smsOptOut?: Maybe<Scalars['Boolean']['output']>;
}

export interface Gds_Question {
  readonly __typename?: 'GDS_Question';
  readonly answerDestination?: Maybe<Scalars['String']['output']>;
  readonly answerType?: Maybe<Scalars['String']['output']>;
  readonly createdAt: Scalars['String']['output'];
  readonly id: Scalars['String']['output'];
  readonly isRequired?: Maybe<Scalars['Boolean']['output']>;
  readonly options?: Maybe<ReadonlyArray<Gds_Option>>;
  readonly text?: Maybe<Scalars['String']['output']>;
  readonly type?: Maybe<Scalars['String']['output']>;
  readonly updatedAt: Scalars['String']['output'];
}

export interface Gds_QuestionResponseData {
  readonly __typename?: 'GDS_QuestionResponseData';
  readonly answerType: Scalars['String']['output'];
  readonly answersData?: Maybe<ReadonlyArray<Maybe<Gds_AnswerData>>>;
  readonly optionCount?: Maybe<Scalars['Int']['output']>;
  readonly questionId: Scalars['String']['output'];
  readonly text: Scalars['String']['output'];
  readonly type: Scalars['String']['output'];
}

export interface Gds_Responder {
  readonly __typename?: 'GDS_Responder';
  readonly firstName?: Maybe<Scalars['String']['output']>;
  readonly lastName?: Maybe<Scalars['String']['output']>;
  readonly personId: Scalars['String']['output'];
}

export interface Gds_SubEvent {
  readonly __typename?: 'GDS_SubEvent';
  readonly attire?: Maybe<Scalars['String']['output']>;
  readonly createdAt: Scalars['String']['output'];
  readonly endTime?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['String']['output'];
  readonly location?: Maybe<Gds_Location>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly notes?: Maybe<Scalars['String']['output']>;
  readonly time?: Maybe<Scalars['String']['output']>;
  readonly type?: Maybe<Scalars['String']['output']>;
  readonly updatedAt: Scalars['String']['output'];
  readonly visible?: Maybe<Scalars['Boolean']['output']>;
}

export interface Gds_UpdateGuestWeddingInput {
  readonly allowGuestPreview?: InputMaybe<Scalars['Boolean']['input']>;
  readonly isPrivateRsvp?: InputMaybe<Scalars['Boolean']['input']>;
  readonly questions?: InputMaybe<ReadonlyArray<Gds_UpdateQuestionInput>>;
  readonly rsvpDeadline?: InputMaybe<Scalars['String']['input']>;
  readonly rsvpMedium?: InputMaybe<Scalars['String']['input']>;
  readonly rsvpPageHidden?: InputMaybe<Scalars['Boolean']['input']>;
  readonly sendRsvpReminder?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface Gds_UpdateGuestWeddingRsvpPropsInput {
  readonly isPrivateRsvp?: InputMaybe<Scalars['Boolean']['input']>;
  readonly rsvpDeadline?: InputMaybe<Scalars['String']['input']>;
  readonly rsvpMedium?: InputMaybe<Scalars['String']['input']>;
}

export interface Gds_UpdateInvitationPatchInput {
  readonly answers?: InputMaybe<ReadonlyArray<Gds_CreateAnswerInput>>;
  readonly gift?: InputMaybe<Scalars['String']['input']>;
  readonly invitationSent?: InputMaybe<Scalars['Boolean']['input']>;
  readonly rsvp?: InputMaybe<Scalars['Boolean']['input']>;
  readonly thankYouSent?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface Gds_UpdateOptionInput {
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly text?: InputMaybe<Scalars['String']['input']>;
}

export interface Gds_UpdateQuestionInput {
  readonly answerDestination?: InputMaybe<Scalars['String']['input']>;
  readonly answerType?: InputMaybe<Scalars['String']['input']>;
  readonly isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  readonly options?: InputMaybe<ReadonlyArray<Gds_UpdateOptionInput>>;
  readonly text?: InputMaybe<Scalars['String']['input']>;
  readonly type?: InputMaybe<Scalars['String']['input']>;
}

export interface Mutation {
  readonly __typename?: 'Mutation';
  readonly addGuestWeddingQuestion: Gds_Question;
  readonly bucketRSVPWorkflow: Gds_GuestWedding;
  readonly createHouseholds: ReadonlyArray<Gds_Household>;
  readonly deleteGuestWeddingQuestion: Scalars['String']['output'];
  readonly deleteInvitation?: Maybe<Gds_DeleteInvitationPayload>;
  readonly insertInvitation?: Maybe<Gds_Invitation>;
  readonly updateGuestWedding: Gds_GuestWedding;
  readonly updateGuestWeddingQuestion: Gds_Question;
  readonly updateGuestWeddingRsvpProps: Gds_GuestWedding;
  readonly updateInvitation?: Maybe<Gds_Invitation>;
}


export type MutationAddGuestWeddingQuestionArgs = {
  input: Gds_UpdateQuestionInput;
};


export type MutationCreateHouseholdsArgs = {
  input: ReadonlyArray<Gds_CreateHouseholdInput>;
};


export type MutationDeleteGuestWeddingQuestionArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteInvitationArgs = {
  input: Gds_DeleteInvitationInput;
};


export type MutationInsertInvitationArgs = {
  householdId: Scalars['String']['input'];
  input: Gds_CreateInvitationInput;
  personId: Scalars['String']['input'];
};


export type MutationUpdateGuestWeddingArgs = {
  input: Gds_UpdateGuestWeddingInput;
};


export type MutationUpdateGuestWeddingQuestionArgs = {
  id: Scalars['String']['input'];
  input: Gds_UpdateQuestionInput;
};


export type MutationUpdateGuestWeddingRsvpPropsArgs = {
  input: Gds_UpdateGuestWeddingRsvpPropsInput;
};


export type MutationUpdateInvitationArgs = {
  householdId: Scalars['String']['input'];
  input: Gds_UpdateInvitationPatchInput;
  invitationId: Scalars['String']['input'];
  personId: Scalars['String']['input'];
};

export interface Query {
  readonly __typename?: 'Query';
  readonly event?: Maybe<Gds_Event>;
  readonly eventQuestionResponseData?: Maybe<ReadonlyArray<Gds_EventQuestionResponseData>>;
  readonly eventRsvpData?: Maybe<ReadonlyArray<Gds_EventRsvpData>>;
  readonly events: ReadonlyArray<Gds_Event>;
  /** Find all themes grouped by family */
  readonly familyThemes: ReadonlyArray<Wws_FamilyThemeType>;
  readonly group?: Maybe<Gds_Group>;
  readonly groups: ReadonlyArray<Gds_Group>;
  readonly guestWedding?: Maybe<Gds_GuestWedding>;
  readonly guestWeddingQuestionResponseData: Gds_GuestWeddingQuestionResponseData;
  readonly household?: Maybe<Gds_Household>;
  readonly households: ReadonlyArray<Gds_Household>;
  readonly householdsWithoutRsvp: ReadonlyArray<Gds_Household>;
  /** Find all themes grouped by family with pagination */
  readonly paginateFamilyThemes: Wws_FamilyThemesPaginatedType;
  readonly person?: Maybe<Gds_Person>;
  /** Find single theme by id */
  readonly theme?: Maybe<Wws_Theme>;
  /** Find all new theme filtering options */
  readonly themeFilterOptions: Wws_ThemeFilterOptions;
  /** Find theme style definitions by theme ID */
  readonly themeStyleDefinitions?: Maybe<ReadonlyArray<Maybe<Scalars['WWS_Json']['output']>>>;
  /** Find all new template themes */
  readonly themes: ReadonlyArray<Wws_Theme>;
  readonly wedding?: Maybe<Wedding>;
  readonly weddingDatePreferences?: Maybe<WeddingDatePreferences>;
  /** Find wedding website by slug or vanity */
  readonly weddingWebsiteResult?: Maybe<Wws_WeddingWebsiteResult>;
}


export type QueryEventArgs = {
  id: Scalars['String']['input'];
};


export type QueryFamilyThemesArgs = {
  variant?: InputMaybe<Wws_FamilyThemeVariant>;
};


export type QueryGroupArgs = {
  id: Scalars['String']['input'];
};


export type QueryHouseholdArgs = {
  id: Scalars['String']['input'];
};


export type QueryHouseholdsWithoutRsvpArgs = {
  eventId: Scalars['String']['input'];
};


export type QueryPaginateFamilyThemesArgs = {
  colors?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  nextCursor?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Wws_ThemeOrder>;
  previousCursor?: InputMaybe<Scalars['Int']['input']>;
  seasons?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  styles?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPersonArgs = {
  id: Scalars['String']['input'];
};


export type QueryThemeArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryThemeStyleDefinitionsArgs = {
  previewId?: InputMaybe<Scalars['String']['input']>;
  themeId: Scalars['Int']['input'];
};


export type QueryWeddingDatePreferencesArgs = {
  pin?: InputMaybe<Scalars['String']['input']>;
};


export type QueryWeddingWebsiteResultArgs = {
  pin?: InputMaybe<Scalars['String']['input']>;
  previewId?: InputMaybe<Scalars['String']['input']>;
  slugOrVanity: Scalars['String']['input'];
};

export interface Season {
  readonly __typename?: 'Season';
  readonly name?: Maybe<SeasonName>;
  readonly year?: Maybe<Scalars['Int']['output']>;
}

export enum SeasonName {
  Fall = 'Fall',
  Spring = 'Spring',
  Summer = 'Summer',
  Winter = 'Winter'
}

export interface Wws_AccommodationItem extends Wws_PageItem {
  readonly __typename?: 'WWS_AccommodationItem';
  readonly address?: Maybe<Scalars['String']['output']>;
  readonly aspectRatio?: Maybe<Wws_AspectRatio>;
  readonly checkInDate?: Maybe<Scalars['String']['output']>;
  readonly checkOutDate?: Maybe<Scalars['String']['output']>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly guestCode?: Maybe<Scalars['String']['output']>;
  readonly guidance?: Maybe<Wws_PageItemGuidance>;
  readonly hotelId?: Maybe<Scalars['String']['output']>;
  readonly hotelPlannerId?: Maybe<Scalars['Int']['output']>;
  readonly id: Scalars['Int']['output'];
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly originalPhoto?: Maybe<Scalars['String']['output']>;
  readonly phone?: Maybe<Scalars['String']['output']>;
  readonly photo?: Maybe<Wws_Photo>;
  readonly photoHeight?: Maybe<Scalars['String']['output']>;
  readonly photoId?: Maybe<Scalars['String']['output']>;
  readonly photoPath?: Maybe<Scalars['String']['output']>;
  readonly photoWidth?: Maybe<Scalars['String']['output']>;
  readonly provider?: Maybe<Scalars['String']['output']>;
  readonly rank: Scalars['Float']['output'];
  readonly rate?: Maybe<Scalars['String']['output']>;
  readonly type: Scalars['String']['output'];
  readonly website?: Maybe<Scalars['String']['output']>;
}

export interface Wws_ActivityItem extends Wws_PageItem {
  readonly __typename?: 'WWS_ActivityItem';
  readonly address?: Maybe<Scalars['String']['output']>;
  readonly aspectRatio?: Maybe<Wws_AspectRatio>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly guidance?: Maybe<Wws_PageItemGuidance>;
  readonly id: Scalars['Int']['output'];
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly originalPhoto?: Maybe<Scalars['String']['output']>;
  readonly phone?: Maybe<Scalars['String']['output']>;
  readonly photo?: Maybe<Wws_Photo>;
  readonly photoHeight?: Maybe<Scalars['String']['output']>;
  readonly photoId?: Maybe<Scalars['String']['output']>;
  readonly photoPath?: Maybe<Scalars['String']['output']>;
  readonly photoWidth?: Maybe<Scalars['String']['output']>;
  readonly rank: Scalars['Float']['output'];
  readonly type: Scalars['String']['output'];
  readonly website?: Maybe<Scalars['String']['output']>;
}

export interface Wws_AlbumPhoto {
  readonly __typename?: 'WWS_AlbumPhoto';
  readonly aspectRatio?: Maybe<Wws_AspectRatio>;
  readonly height?: Maybe<Scalars['Int']['output']>;
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly mediaApiId?: Maybe<Scalars['String']['output']>;
  readonly mediaUrl: Scalars['String']['output'];
  readonly photoAlbumId?: Maybe<Scalars['Int']['output']>;
  readonly rank?: Maybe<Scalars['Int']['output']>;
  readonly width?: Maybe<Scalars['Int']['output']>;
}

export interface Wws_Announcement {
  readonly __typename?: 'WWS_Announcement';
  readonly icon?: Maybe<Scalars['Int']['output']>;
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly message: Scalars['String']['output'];
  readonly show: Scalars['Boolean']['output'];
  readonly title?: Maybe<Scalars['String']['output']>;
}

export interface Wws_AspectRatio {
  readonly __typename?: 'WWS_AspectRatio';
  readonly height: Scalars['Int']['output'];
  readonly id: Scalars['String']['output'];
  readonly name: Scalars['String']['output'];
  readonly value: Scalars['Float']['output'];
  readonly width: Scalars['Int']['output'];
}

export interface Wws_BasicItem extends Wws_PageItem {
  readonly __typename?: 'WWS_BasicItem';
  readonly aspectRatio?: Maybe<Wws_AspectRatio>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly guidance?: Maybe<Wws_PageItemGuidance>;
  readonly id: Scalars['Int']['output'];
  readonly originalPhoto?: Maybe<Scalars['String']['output']>;
  readonly photo?: Maybe<Wws_Photo>;
  readonly photoHeight?: Maybe<Scalars['String']['output']>;
  readonly photoId?: Maybe<Scalars['String']['output']>;
  readonly photoPath?: Maybe<Scalars['String']['output']>;
  readonly photoWidth?: Maybe<Scalars['String']['output']>;
  readonly rank: Scalars['Float']['output'];
  readonly title?: Maybe<Scalars['String']['output']>;
  readonly type: Scalars['String']['output'];
}

export interface Wws_ContentItem {
  readonly __typename?: 'WWS_ContentItem';
  readonly aspectRatio?: Maybe<Wws_AspectRatio>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly order?: Maybe<Scalars['Int']['output']>;
  readonly originalPhoto?: Maybe<Scalars['String']['output']>;
  readonly partnerFlg?: Maybe<Scalars['Boolean']['output']>;
  readonly photoHeight?: Maybe<Scalars['String']['output']>;
  readonly photoId?: Maybe<Scalars['String']['output']>;
  readonly photoPath?: Maybe<Scalars['String']['output']>;
  readonly photoWidth?: Maybe<Scalars['String']['output']>;
  readonly title?: Maybe<Scalars['String']['output']>;
  readonly type?: Maybe<Scalars['String']['output']>;
  readonly visible?: Maybe<Scalars['Boolean']['output']>;
}

export interface Wws_CoverPhoto {
  readonly __typename?: 'WWS_CoverPhoto';
  readonly aspectRatio?: Maybe<Wws_AspectRatio>;
  readonly cropBox?: Maybe<Scalars['String']['output']>;
  readonly height?: Maybe<Scalars['Int']['output']>;
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly mobileCropBox?: Maybe<Scalars['String']['output']>;
  readonly originalMediaUrl?: Maybe<Scalars['String']['output']>;
  readonly path?: Maybe<Scalars['String']['output']>;
  readonly rotationAngle?: Maybe<Scalars['String']['output']>;
  readonly width?: Maybe<Scalars['Int']['output']>;
}

export interface Wws_CoverPhotoItem extends Wws_PageItem {
  readonly __typename?: 'WWS_CoverPhotoItem';
  readonly aspectRatio?: Maybe<Wws_AspectRatio>;
  readonly caption?: Maybe<Scalars['String']['output']>;
  readonly cropX?: Maybe<Scalars['Int']['output']>;
  readonly cropY?: Maybe<Scalars['Int']['output']>;
  readonly date?: Maybe<Scalars['String']['output']>;
  readonly focalPoint?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly guidance?: Maybe<Wws_PageItemGuidance>;
  readonly height: Scalars['Int']['output'];
  readonly id: Scalars['Int']['output'];
  readonly mediaApiId: Scalars['String']['output'];
  readonly mediaUrl: Scalars['String']['output'];
  readonly originalPhoto?: Maybe<Scalars['String']['output']>;
  readonly photoHeight?: Maybe<Scalars['String']['output']>;
  readonly photoId?: Maybe<Scalars['String']['output']>;
  readonly photoPath?: Maybe<Scalars['String']['output']>;
  readonly photoWidth?: Maybe<Scalars['String']['output']>;
  readonly rank: Scalars['Float']['output'];
  readonly rotation?: Maybe<Scalars['Int']['output']>;
  readonly type: Scalars['String']['output'];
  readonly width: Scalars['Int']['output'];
}

export interface Wws_DressCodeArticle {
  readonly __typename?: 'WWS_DressCodeArticle';
  readonly imageUrl: Scalars['String']['output'];
  readonly title: Scalars['String']['output'];
  readonly url: Scalars['String']['output'];
}

export interface Wws_DressCodeItem extends Wws_PageItem {
  readonly __typename?: 'WWS_DressCodeItem';
  readonly articles?: Maybe<ReadonlyArray<Maybe<Wws_DressCodeArticle>>>;
  readonly attireCategoryId?: Maybe<Scalars['String']['output']>;
  readonly attireDescription?: Maybe<Scalars['String']['output']>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly eventId?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['Int']['output'];
  readonly rank: Scalars['Float']['output'];
  readonly showAffiliates?: Maybe<Scalars['Boolean']['output']>;
  readonly showArticles?: Maybe<Scalars['Boolean']['output']>;
  readonly type: Scalars['String']['output'];
}

export interface Wws_EmbedItem extends Wws_PageItem {
  readonly __typename?: 'WWS_EmbedItem';
  readonly aspectRatio?: Maybe<Wws_AspectRatio>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly embededCode: Scalars['String']['output'];
  readonly guidance?: Maybe<Wws_PageItemGuidance>;
  readonly id: Scalars['Int']['output'];
  readonly mediaService: Scalars['String']['output'];
  readonly originalPhoto?: Maybe<Scalars['String']['output']>;
  readonly photoHeight?: Maybe<Scalars['String']['output']>;
  readonly photoId?: Maybe<Scalars['String']['output']>;
  readonly photoPath?: Maybe<Scalars['String']['output']>;
  readonly photoWidth?: Maybe<Scalars['String']['output']>;
  readonly rank: Scalars['Float']['output'];
  readonly title?: Maybe<Scalars['String']['output']>;
  readonly type: Scalars['String']['output'];
}

export interface Wws_Error extends Wws_WeddingWebsiteResult {
  readonly __typename?: 'WWS_Error';
  readonly cause?: Maybe<Scalars['String']['output']>;
  readonly message?: Maybe<Scalars['String']['output']>;
  readonly theme?: Maybe<Wws_Theme>;
  readonly weddingUuid?: Maybe<Scalars['String']['output']>;
}

export interface Wws_EventGroupItem extends Wws_PageItem {
  readonly __typename?: 'WWS_EventGroupItem';
  readonly aspectRatio?: Maybe<Wws_AspectRatio>;
  readonly guidance?: Maybe<Wws_PageItemGuidance>;
  readonly id: Scalars['Int']['output'];
  readonly originalPhoto?: Maybe<Scalars['String']['output']>;
  readonly photoHeight?: Maybe<Scalars['String']['output']>;
  readonly photoId?: Maybe<Scalars['String']['output']>;
  readonly photoPath?: Maybe<Scalars['String']['output']>;
  readonly photoWidth?: Maybe<Scalars['String']['output']>;
  readonly rank: Scalars['Float']['output'];
  readonly type: Scalars['String']['output'];
}

export interface Wws_FamilyThemeSummaryType {
  readonly __typename?: 'WWS_FamilyThemeSummaryType';
  readonly family?: Maybe<Scalars['String']['output']>;
  readonly themes?: Maybe<ReadonlyArray<Wws_ThemeSummary>>;
}

export interface Wws_FamilyThemeType {
  readonly __typename?: 'WWS_FamilyThemeType';
  readonly family?: Maybe<Scalars['String']['output']>;
  readonly themes?: Maybe<ReadonlyArray<Wws_Theme>>;
}

export enum Wws_FamilyThemeVariant {
  /** Lite Site Control */
  Control = 'CONTROL',
  /** Lite Site */
  Lite = 'LITE',
  /** Control */
  Random = 'RANDOM',
  /** Data Training */
  Training = 'TRAINING'
}

export interface Wws_FamilyThemesPaginatedType {
  readonly __typename?: 'WWS_FamilyThemesPaginatedType';
  readonly hasMore: Scalars['Boolean']['output'];
  readonly hasPrevious: Scalars['Boolean']['output'];
  readonly nextCursor?: Maybe<Scalars['Int']['output']>;
  readonly previousCursor?: Maybe<Scalars['Int']['output']>;
  readonly results?: Maybe<ReadonlyArray<Wws_FamilyThemeSummaryType>>;
}

export interface Wws_GifItem extends Wws_PageItem {
  readonly __typename?: 'WWS_GifItem';
  readonly aspectRatio?: Maybe<Wws_AspectRatio>;
  readonly guidance?: Maybe<Wws_PageItemGuidance>;
  readonly id: Scalars['Int']['output'];
  readonly mediaApiId: Scalars['String']['output'];
  readonly mediaUrl: Scalars['String']['output'];
  readonly originalPhoto?: Maybe<Scalars['String']['output']>;
  readonly photoHeight?: Maybe<Scalars['String']['output']>;
  readonly photoId?: Maybe<Scalars['String']['output']>;
  readonly photoPath?: Maybe<Scalars['String']['output']>;
  readonly photoWidth?: Maybe<Scalars['String']['output']>;
  readonly rank: Scalars['Float']['output'];
  readonly type: Scalars['String']['output'];
}

export interface Wws_GroupItem extends Wws_PageItem {
  readonly __typename?: 'WWS_GroupItem';
  readonly aspectRatio?: Maybe<Wws_AspectRatio>;
  readonly childItems?: Maybe<ReadonlyArray<Wws_PageItem>>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly guidance?: Maybe<Wws_PageItemGuidance>;
  readonly id: Scalars['Int']['output'];
  readonly originalPhoto?: Maybe<Scalars['String']['output']>;
  readonly photoHeight?: Maybe<Scalars['String']['output']>;
  readonly photoId?: Maybe<Scalars['String']['output']>;
  readonly photoPath?: Maybe<Scalars['String']['output']>;
  readonly photoWidth?: Maybe<Scalars['String']['output']>;
  readonly rank: Scalars['Float']['output'];
  readonly title?: Maybe<Scalars['String']['output']>;
  readonly type: Scalars['String']['output'];
}

export interface Wws_HeadlineItem extends Wws_PageItem {
  readonly __typename?: 'WWS_HeadlineItem';
  readonly aspectRatio?: Maybe<Wws_AspectRatio>;
  readonly guidance?: Maybe<Wws_PageItemGuidance>;
  readonly id: Scalars['Int']['output'];
  readonly originalPhoto?: Maybe<Scalars['String']['output']>;
  readonly photoHeight?: Maybe<Scalars['String']['output']>;
  readonly photoId?: Maybe<Scalars['String']['output']>;
  readonly photoPath?: Maybe<Scalars['String']['output']>;
  readonly photoWidth?: Maybe<Scalars['String']['output']>;
  readonly rank: Scalars['Float']['output'];
  readonly style?: Maybe<Scalars['String']['output']>;
  readonly title?: Maybe<Scalars['String']['output']>;
  readonly type: Scalars['String']['output'];
}

export interface Wws_Image {
  readonly __typename?: 'WWS_Image';
  readonly aspectRatio?: Maybe<Wws_AspectRatio>;
  readonly caption?: Maybe<Scalars['String']['output']>;
  readonly columnNumber?: Maybe<Scalars['Int']['output']>;
  readonly galleryPath?: Maybe<Scalars['String']['output']>;
  readonly height?: Maybe<Scalars['Int']['output']>;
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly mediaApiId?: Maybe<Scalars['String']['output']>;
  readonly mediaUrl: Scalars['String']['output'];
  readonly path?: Maybe<Scalars['String']['output']>;
  readonly photoAlbumId?: Maybe<Scalars['Int']['output']>;
  readonly rank?: Maybe<Scalars['Int']['output']>;
  readonly rankedOrder?: Maybe<Scalars['Int']['output']>;
  readonly type?: Maybe<Scalars['String']['output']>;
  readonly width?: Maybe<Scalars['Int']['output']>;
}

export interface Wws_ImageType {
  readonly __typename?: 'WWS_ImageType';
  readonly aspectRatios: ReadonlyArray<Wws_AspectRatio>;
  readonly defaultAspectRatio: Wws_AspectRatio;
  readonly name: Scalars['String']['output'];
}

export interface Wws_LivestreamItem extends Wws_PageItem {
  readonly __typename?: 'WWS_LivestreamItem';
  readonly aspectRatio?: Maybe<Wws_AspectRatio>;
  readonly buttonText?: Maybe<Scalars['String']['output']>;
  readonly buttonUrl?: Maybe<Scalars['String']['output']>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly guidance?: Maybe<Wws_PageItemGuidance>;
  readonly id: Scalars['Int']['output'];
  readonly originalPhoto?: Maybe<Scalars['String']['output']>;
  readonly photoHeight?: Maybe<Scalars['String']['output']>;
  readonly photoId?: Maybe<Scalars['String']['output']>;
  readonly photoPath?: Maybe<Scalars['String']['output']>;
  readonly photoWidth?: Maybe<Scalars['String']['output']>;
  readonly rank: Scalars['Float']['output'];
  readonly title?: Maybe<Scalars['String']['output']>;
  readonly type: Scalars['String']['output'];
}

export interface Wws_Location {
  readonly __typename?: 'WWS_Location';
  readonly addressComponents?: Maybe<Scalars['WWS_Json']['output']>;
  readonly fullAddress?: Maybe<Scalars['String']['output']>;
  readonly googlePlaceId?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly venueName?: Maybe<Scalars['String']['output']>;
}

export interface Wws_LocationContent {
  readonly __typename?: 'WWS_LocationContent';
  readonly aspectRatio?: Maybe<Wws_AspectRatio>;
  readonly checkInDate?: Maybe<Scalars['String']['output']>;
  readonly checkOutDate?: Maybe<Scalars['String']['output']>;
  readonly confirmationState?: Maybe<Scalars['String']['output']>;
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly expediaId?: Maybe<Scalars['String']['output']>;
  readonly guestCode?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly location?: Maybe<Wws_Location>;
  readonly memberWeddingId?: Maybe<Scalars['Int']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly notes?: Maybe<Scalars['String']['output']>;
  readonly order?: Maybe<Scalars['Int']['output']>;
  readonly originalPhoto?: Maybe<Scalars['String']['output']>;
  readonly phone?: Maybe<Scalars['String']['output']>;
  readonly photoHeight?: Maybe<Scalars['String']['output']>;
  readonly photoId?: Maybe<Scalars['String']['output']>;
  readonly photoPath?: Maybe<Scalars['String']['output']>;
  readonly photoWidth?: Maybe<Scalars['String']['output']>;
  readonly rate?: Maybe<Scalars['String']['output']>;
  readonly type?: Maybe<Scalars['String']['output']>;
  readonly website?: Maybe<Scalars['String']['output']>;
}

export interface Wws_MediaApiImage {
  readonly __typename?: 'WWS_MediaApiImage';
  readonly mediaApiId: Scalars['String']['output'];
  readonly path?: Maybe<Scalars['String']['output']>;
}

export interface Wws_Page {
  readonly __typename?: 'WWS_Page';
  /** Find a Accommodation Item by ID and Page ID */
  readonly accommodationItem?: Maybe<Wws_AccommodationItem>;
  readonly accommodationItems: ReadonlyArray<Wws_AccommodationItem>;
  /** Find a Activity Item by ID and Page ID */
  readonly activityItem?: Maybe<Wws_ActivityItem>;
  /** Find a Basic Item by ID and Page ID */
  readonly basicItem?: Maybe<Wws_BasicItem>;
  /** Find a Cover Photo Item by ID and Page ID */
  readonly coverPhotoItem?: Maybe<Wws_CoverPhotoItem>;
  readonly description?: Maybe<Scalars['String']['output']>;
  /** Find a Dress Code Item by ID and Page ID */
  readonly dressCodeItem?: Maybe<Wws_DressCodeItem>;
  /** Find a Embed Item by ID and Page ID */
  readonly embedItem?: Maybe<Wws_EmbedItem>;
  /** Find a Gif Item by ID and Page ID */
  readonly gifItem?: Maybe<Wws_GifItem>;
  /** Find a Headline Item by ID and Page ID */
  readonly headlineItem?: Maybe<Wws_HeadlineItem>;
  readonly id: Scalars['Int']['output'];
  readonly items: ReadonlyArray<Wws_PageItem>;
  /** Find a Livestream Item by and Page ID */
  readonly livestreamItem?: Maybe<Wws_LivestreamItem>;
  readonly pageGuidance?: Maybe<Wws_PageGuidance>;
  readonly pageItemGuidances?: Maybe<ReadonlyArray<Wws_PageItemGuidance>>;
  /** @deprecated Moved into pageItemGuidances */
  readonly pageItemTypes: ReadonlyArray<Scalars['String']['output']>;
  /** @deprecated Please use items field, this is a duplicate. */
  readonly pageItems: ReadonlyArray<Wws_PageItem>;
  /** Find a Paragraph Item by ID and Page ID */
  readonly paragraphItem?: Maybe<Wws_ParagraphItem>;
  /** Find a Person Item by ID and Page ID */
  readonly personItem?: Maybe<Wws_PersonItem>;
  /** Find a Photo Gallery Item by ID and Page ID */
  readonly photoGalleryItem?: Maybe<Wws_PhotoGalleryItem>;
  /** Find a Photo Item by ID and Page ID */
  readonly photoItem?: Maybe<Wws_PhotoItem>;
  /** Find a Photo Timeline Item by ID and Page ID */
  readonly photoTimelineItem?: Maybe<Wws_PhotoTimelineItem>;
  /** Find a Question Item by and Page ID */
  readonly questionItem?: Maybe<Wws_QuestionItem>;
  readonly rank?: Maybe<Scalars['Int']['output']>;
  readonly routeName?: Maybe<Scalars['String']['output']>;
  readonly sections?: Maybe<ReadonlyArray<Wws_Section>>;
  readonly show?: Maybe<Scalars['Boolean']['output']>;
  /** Find a Story Item by ID and Page ID */
  readonly storyItem?: Maybe<Wws_StoryItem>;
  readonly supportedImageTypes: ReadonlyArray<Wws_ImageType>;
  readonly title?: Maybe<Scalars['String']['output']>;
  /** Find a Transportation Item by ID and Page ID */
  readonly transportationItem?: Maybe<Wws_TransportationItem>;
  readonly type: Scalars['String']['output'];
}


export type Wws_PageAccommodationItemArgs = {
  id: Scalars['Int']['input'];
};


export type Wws_PageActivityItemArgs = {
  id: Scalars['Int']['input'];
};


export type Wws_PageBasicItemArgs = {
  id: Scalars['Int']['input'];
};


export type Wws_PageCoverPhotoItemArgs = {
  id: Scalars['Int']['input'];
};


export type Wws_PageDressCodeItemArgs = {
  id: Scalars['Int']['input'];
};


export type Wws_PageEmbedItemArgs = {
  id: Scalars['Int']['input'];
};


export type Wws_PageGifItemArgs = {
  id: Scalars['Int']['input'];
};


export type Wws_PageHeadlineItemArgs = {
  id: Scalars['Int']['input'];
};


export type Wws_PageLivestreamItemArgs = {
  id: Scalars['Int']['input'];
};


export type Wws_PageParagraphItemArgs = {
  id: Scalars['Int']['input'];
};


export type Wws_PagePersonItemArgs = {
  id: Scalars['Int']['input'];
};


export type Wws_PagePhotoGalleryItemArgs = {
  id: Scalars['Int']['input'];
};


export type Wws_PagePhotoItemArgs = {
  id: Scalars['Int']['input'];
};


export type Wws_PagePhotoTimelineItemArgs = {
  id: Scalars['Int']['input'];
};


export type Wws_PageQuestionItemArgs = {
  id: Scalars['Int']['input'];
};


export type Wws_PageStoryItemArgs = {
  id: Scalars['Int']['input'];
};


export type Wws_PageTransportationItemArgs = {
  id: Scalars['Int']['input'];
};

export interface Wws_PageGuidance {
  readonly __typename?: 'WWS_PageGuidance';
  readonly hiddenPageDescription?: Maybe<Scalars['String']['output']>;
  readonly visiblePageDescription?: Maybe<Scalars['String']['output']>;
}

/** A Page Item */
export type Wws_PageItem = {
  readonly id: Scalars['Int']['output'];
  readonly rank: Scalars['Float']['output'];
  readonly type: Scalars['String']['output'];
};

export interface Wws_PageItemGuidance {
  readonly __typename?: 'WWS_PageItemGuidance';
  readonly ctaText?: Maybe<Scalars['String']['output']>;
  readonly icon?: Maybe<Scalars['String']['output']>;
  readonly image?: Maybe<Wws_MediaApiImage>;
  readonly type?: Maybe<Scalars['String']['output']>;
}

export interface Wws_ParagraphItem extends Wws_PageItem {
  readonly __typename?: 'WWS_ParagraphItem';
  readonly aspectRatio?: Maybe<Wws_AspectRatio>;
  readonly content: Scalars['String']['output'];
  readonly guidance?: Maybe<Wws_PageItemGuidance>;
  readonly id: Scalars['Int']['output'];
  readonly originalPhoto?: Maybe<Scalars['String']['output']>;
  readonly photoHeight?: Maybe<Scalars['String']['output']>;
  readonly photoId?: Maybe<Scalars['String']['output']>;
  readonly photoPath?: Maybe<Scalars['String']['output']>;
  readonly photoWidth?: Maybe<Scalars['String']['output']>;
  readonly rank: Scalars['Float']['output'];
  readonly textContent: Scalars['String']['output'];
  readonly type: Scalars['String']['output'];
}

export interface Wws_PersonItem extends Wws_PageItem {
  readonly __typename?: 'WWS_PersonItem';
  readonly aspectRatio?: Maybe<Wws_AspectRatio>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly guidance?: Maybe<Wws_PageItemGuidance>;
  readonly id: Scalars['Int']['output'];
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly originalPhoto?: Maybe<Scalars['String']['output']>;
  readonly photo?: Maybe<Wws_Photo>;
  readonly photoHeight?: Maybe<Scalars['String']['output']>;
  readonly photoId?: Maybe<Scalars['String']['output']>;
  readonly photoPath?: Maybe<Scalars['String']['output']>;
  readonly photoWidth?: Maybe<Scalars['String']['output']>;
  readonly rank: Scalars['Float']['output'];
  readonly role?: Maybe<Scalars['String']['output']>;
  readonly type: Scalars['String']['output'];
}

export interface Wws_Photo {
  readonly __typename?: 'WWS_Photo';
  readonly aspectRatio?: Maybe<Wws_AspectRatio>;
  readonly caption?: Maybe<Scalars['String']['output']>;
  readonly cropX?: Maybe<Scalars['Int']['output']>;
  readonly cropY?: Maybe<Scalars['Int']['output']>;
  readonly height?: Maybe<Scalars['Int']['output']>;
  readonly mediaApiId: Scalars['String']['output'];
  readonly mediaUrl: Scalars['String']['output'];
  readonly originalMediaUrl: Scalars['String']['output'];
  readonly rotation?: Maybe<Scalars['Int']['output']>;
  readonly timestamp?: Maybe<Scalars['String']['output']>;
  readonly width?: Maybe<Scalars['Int']['output']>;
}

export interface Wws_PhotoAlbum {
  readonly __typename?: 'WWS_PhotoAlbum';
  readonly coverPhoto?: Maybe<Wws_Image>;
  readonly fbAlbumId?: Maybe<Scalars['String']['output']>;
  readonly fbSync?: Maybe<Scalars['Boolean']['output']>;
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly images?: Maybe<ReadonlyArray<Wws_Image>>;
  readonly importing?: Maybe<Scalars['Boolean']['output']>;
  readonly instagramAlbum?: Maybe<Scalars['Boolean']['output']>;
  readonly memberWeddingId?: Maybe<Scalars['Int']['output']>;
  readonly order?: Maybe<Scalars['Int']['output']>;
  readonly photos: ReadonlyArray<Wws_AlbumPhoto>;
  readonly rank?: Maybe<Scalars['Int']['output']>;
  readonly title?: Maybe<Scalars['String']['output']>;
  readonly type?: Maybe<Scalars['String']['output']>;
  readonly updatedAt?: Maybe<Scalars['String']['output']>;
}

export interface Wws_PhotoGalleryItem extends Wws_PageItem {
  readonly __typename?: 'WWS_PhotoGalleryItem';
  readonly aspectRatio?: Maybe<Wws_AspectRatio>;
  readonly guidance?: Maybe<Wws_PageItemGuidance>;
  readonly id: Scalars['Int']['output'];
  readonly layout: Scalars['String']['output'];
  readonly originalPhoto?: Maybe<Scalars['String']['output']>;
  readonly photoHeight?: Maybe<Scalars['String']['output']>;
  readonly photoId?: Maybe<Scalars['String']['output']>;
  readonly photoItems: ReadonlyArray<Wws_PhotoItem>;
  readonly photoPath?: Maybe<Scalars['String']['output']>;
  readonly photoWidth?: Maybe<Scalars['String']['output']>;
  readonly rank: Scalars['Float']['output'];
  readonly type: Scalars['String']['output'];
}

export interface Wws_PhotoItem extends Wws_PageItem {
  readonly __typename?: 'WWS_PhotoItem';
  readonly aspectRatio?: Maybe<Wws_AspectRatio>;
  readonly caption?: Maybe<Scalars['String']['output']>;
  readonly cropX?: Maybe<Scalars['Int']['output']>;
  readonly cropY?: Maybe<Scalars['Int']['output']>;
  readonly date?: Maybe<Scalars['String']['output']>;
  readonly guidance?: Maybe<Wws_PageItemGuidance>;
  readonly height: Scalars['Int']['output'];
  readonly id: Scalars['Int']['output'];
  readonly mediaApiId: Scalars['String']['output'];
  readonly mediaUrl: Scalars['String']['output'];
  readonly originalPhoto?: Maybe<Scalars['String']['output']>;
  readonly photoHeight?: Maybe<Scalars['String']['output']>;
  readonly photoId?: Maybe<Scalars['String']['output']>;
  readonly photoPath?: Maybe<Scalars['String']['output']>;
  readonly photoWidth?: Maybe<Scalars['String']['output']>;
  readonly rank: Scalars['Float']['output'];
  readonly rotation?: Maybe<Scalars['Int']['output']>;
  readonly type: Scalars['String']['output'];
  readonly width: Scalars['Int']['output'];
}

export interface Wws_PhotoTimelineItem extends Wws_PageItem {
  readonly __typename?: 'WWS_PhotoTimelineItem';
  readonly aspectRatio?: Maybe<Wws_AspectRatio>;
  readonly guidance?: Maybe<Wws_PageItemGuidance>;
  readonly id: Scalars['Int']['output'];
  readonly layout: Scalars['String']['output'];
  readonly originalPhoto?: Maybe<Scalars['String']['output']>;
  readonly photoHeight?: Maybe<Scalars['String']['output']>;
  readonly photoId?: Maybe<Scalars['String']['output']>;
  readonly photoItems: ReadonlyArray<Wws_PhotoItem>;
  readonly photoPath?: Maybe<Scalars['String']['output']>;
  readonly photoWidth?: Maybe<Scalars['String']['output']>;
  readonly rank: Scalars['Float']['output'];
  readonly type: Scalars['String']['output'];
}

export interface Wws_PurchaseDomain {
  readonly __typename?: 'WWS_PurchaseDomain';
  readonly createdAt: Scalars['String']['output'];
  readonly dateOfLastRenewal?: Maybe<Scalars['String']['output']>;
  readonly expirationDate?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly isExpired?: Maybe<Scalars['Boolean']['output']>;
  readonly isInRedemptionPeriod: Scalars['Boolean']['output'];
  /** @deprecated use show_renewal */
  readonly isRenewable?: Maybe<Scalars['Boolean']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly renewalPrice: Scalars['Float']['output'];
  readonly showRenewal?: Maybe<Scalars['Boolean']['output']>;
}

export interface Wws_QuestionItem extends Wws_PageItem {
  readonly __typename?: 'WWS_QuestionItem';
  readonly answer: Scalars['String']['output'];
  readonly aspectRatio?: Maybe<Wws_AspectRatio>;
  readonly guidance?: Maybe<Wws_PageItemGuidance>;
  readonly id: Scalars['Int']['output'];
  readonly originalPhoto?: Maybe<Scalars['String']['output']>;
  readonly photoHeight?: Maybe<Scalars['String']['output']>;
  readonly photoId?: Maybe<Scalars['String']['output']>;
  readonly photoPath?: Maybe<Scalars['String']['output']>;
  readonly photoWidth?: Maybe<Scalars['String']['output']>;
  readonly question: Scalars['String']['output'];
  readonly rank: Scalars['Float']['output'];
  readonly type: Scalars['String']['output'];
}

export interface Wws_Section {
  readonly __typename?: 'WWS_Section';
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly items?: Maybe<ReadonlyArray<Wws_SectionContent>>;
  readonly rank?: Maybe<Scalars['Int']['output']>;
  readonly show?: Maybe<Scalars['Boolean']['output']>;
  readonly showTitle?: Maybe<Scalars['Boolean']['output']>;
  readonly title?: Maybe<Scalars['String']['output']>;
  readonly type?: Maybe<Scalars['String']['output']>;
}

/** Items which can appear in sections */
export type Wws_SectionContent = Wws_ContentItem | Wws_LocationContent | Wws_PhotoAlbum | Wws_SectionItem | Wws_Story;

export interface Wws_SectionItem {
  readonly __typename?: 'WWS_SectionItem';
  readonly aspectRatio?: Maybe<Wws_AspectRatio>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly order?: Maybe<Scalars['Int']['output']>;
  readonly originalPhoto?: Maybe<Scalars['String']['output']>;
  readonly photoHeight?: Maybe<Scalars['String']['output']>;
  readonly photoId?: Maybe<Scalars['String']['output']>;
  readonly photoPath?: Maybe<Scalars['String']['output']>;
  readonly photoWidth?: Maybe<Scalars['String']['output']>;
  readonly title?: Maybe<Scalars['String']['output']>;
}

export interface Wws_Story {
  readonly __typename?: 'WWS_Story';
  readonly aspectRatio?: Maybe<Wws_AspectRatio>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly order?: Maybe<Scalars['Int']['output']>;
  readonly originalPhoto?: Maybe<Scalars['String']['output']>;
  readonly photoHeight?: Maybe<Scalars['String']['output']>;
  readonly photoId?: Maybe<Scalars['String']['output']>;
  readonly photoPath?: Maybe<Scalars['String']['output']>;
  readonly photoWidth?: Maybe<Scalars['String']['output']>;
  readonly title?: Maybe<Scalars['String']['output']>;
}

export interface Wws_StoryItem extends Wws_PageItem {
  readonly __typename?: 'WWS_StoryItem';
  readonly aspectRatio?: Maybe<Wws_AspectRatio>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly guidance?: Maybe<Wws_PageItemGuidance>;
  readonly id: Scalars['Int']['output'];
  readonly originalPhoto?: Maybe<Scalars['String']['output']>;
  readonly photo?: Maybe<Wws_Photo>;
  readonly photoHeight?: Maybe<Scalars['String']['output']>;
  readonly photoId?: Maybe<Scalars['String']['output']>;
  readonly photoPath?: Maybe<Scalars['String']['output']>;
  readonly photoWidth?: Maybe<Scalars['String']['output']>;
  readonly rank: Scalars['Float']['output'];
  readonly title?: Maybe<Scalars['String']['output']>;
  readonly type: Scalars['String']['output'];
}

export interface Wws_Theme {
  readonly __typename?: 'WWS_Theme';
  readonly active?: Maybe<Scalars['Boolean']['output']>;
  readonly batch?: Maybe<Scalars['Int']['output']>;
  readonly carouselImages?: Maybe<Scalars['WWS_Json']['output']>;
  readonly categoryData?: Maybe<Scalars['WWS_Json']['output']>;
  readonly cssFile?: Maybe<Scalars['String']['output']>;
  readonly designerUrl?: Maybe<Scalars['String']['output']>;
  readonly family?: Maybe<Scalars['String']['output']>;
  readonly familyThemes?: Maybe<ReadonlyArray<Wws_Theme>>;
  readonly folderPrefix?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly layoutCoverPhotoRatio?: Maybe<Scalars['String']['output']>;
  readonly layoutId?: Maybe<Scalars['Int']['output']>;
  readonly liteSite?: Maybe<Scalars['Boolean']['output']>;
  readonly mobilePreviewImage?: Maybe<Wws_Photo>;
  readonly mobilePreviewUrl?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly previewImage?: Maybe<Wws_Photo>;
  readonly previewUrl?: Maybe<Scalars['String']['output']>;
  readonly stationaryPreviewImage?: Maybe<Wws_Photo>;
  readonly stationaryPreviewUrl?: Maybe<Scalars['String']['output']>;
  readonly styles?: Maybe<ReadonlyArray<Wws_ThemeStyle>>;
  readonly swatchImage?: Maybe<Wws_Photo>;
  readonly swatchUrl?: Maybe<Scalars['String']['output']>;
  readonly templateVersion?: Maybe<Scalars['Int']['output']>;
  readonly testRank?: Maybe<Scalars['Int']['output']>;
  readonly thankYouUrl?: Maybe<Scalars['String']['output']>;
  readonly themeDesigner?: Maybe<Wws_ThemeDesigner>;
  readonly themeStyles?: Maybe<Scalars['WWS_Json']['output']>;
  readonly version?: Maybe<Scalars['Int']['output']>;
}

export interface Wws_ThemeDesigner {
  readonly __typename?: 'WWS_ThemeDesigner';
  readonly companyName?: Maybe<Scalars['String']['output']>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly logo?: Maybe<Scalars['String']['output']>;
  readonly logoHeight?: Maybe<Scalars['Int']['output']>;
  readonly logoWidth?: Maybe<Scalars['Int']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly url?: Maybe<Scalars['String']['output']>;
}

export interface Wws_ThemeFilterOption {
  readonly __typename?: 'WWS_ThemeFilterOption';
  /** The key identifier for the theme filter option. Ex. "classic" */
  readonly key: Scalars['String']['output'];
  /** The display name of the theme filter option. Ex. "Classic and Elegant" */
  readonly label: Scalars['String']['output'];
}

export interface Wws_ThemeFilterOptions {
  readonly __typename?: 'WWS_ThemeFilterOptions';
  /** Find all available colors for themes */
  readonly colors: ReadonlyArray<Scalars['String']['output']>;
  /** Find all available seasons for themes */
  readonly seasons: ReadonlyArray<Scalars['String']['output']>;
  /** Find all available styles for themes */
  readonly themeStyles: ReadonlyArray<Wws_ThemeFilterOption>;
}

export enum Wws_ThemeOrder {
  /** Order randomly */
  Random = 'RANDOM',
  /** Order by rank ascending */
  RankedAsc = 'RANKED_ASC'
}

export interface Wws_ThemeStyle {
  readonly __typename?: 'WWS_ThemeStyle';
  readonly color?: Maybe<Scalars['String']['output']>;
  readonly element?: Maybe<Scalars['String']['output']>;
  readonly fontFamily?: Maybe<Scalars['String']['output']>;
  readonly fontSize?: Maybe<Scalars['String']['output']>;
  readonly fontStyle?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
}

export interface Wws_ThemeSummary {
  readonly __typename?: 'WWS_ThemeSummary';
  readonly active?: Maybe<Scalars['Boolean']['output']>;
  readonly batch?: Maybe<Scalars['Int']['output']>;
  readonly carouselImages?: Maybe<Scalars['WWS_Json']['output']>;
  readonly categoryData?: Maybe<Scalars['WWS_Json']['output']>;
  readonly cssFile?: Maybe<Scalars['String']['output']>;
  readonly designerUrl?: Maybe<Scalars['String']['output']>;
  readonly family?: Maybe<Scalars['String']['output']>;
  readonly familyThemes?: Maybe<ReadonlyArray<Wws_Theme>>;
  readonly folderPrefix?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly layoutCoverPhotoRatio?: Maybe<Scalars['String']['output']>;
  readonly layoutId?: Maybe<Scalars['Int']['output']>;
  readonly liteSite?: Maybe<Scalars['Boolean']['output']>;
  readonly mobilePreviewImage?: Maybe<Wws_Photo>;
  readonly mobilePreviewUrl?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly previewImage?: Maybe<Wws_Photo>;
  readonly previewUrl?: Maybe<Scalars['String']['output']>;
  readonly stationaryPreviewImage?: Maybe<Wws_Photo>;
  readonly stationaryPreviewUrl?: Maybe<Scalars['String']['output']>;
  readonly swatchImage?: Maybe<Wws_Photo>;
  readonly swatchUrl?: Maybe<Scalars['String']['output']>;
  readonly templateVersion?: Maybe<Scalars['Int']['output']>;
  readonly testRank?: Maybe<Scalars['Int']['output']>;
  readonly thankYouUrl?: Maybe<Scalars['String']['output']>;
  readonly themeDesigner?: Maybe<Wws_ThemeDesigner>;
  readonly version?: Maybe<Scalars['Int']['output']>;
}

export interface Wws_TransportationItem extends Wws_PageItem {
  readonly __typename?: 'WWS_TransportationItem';
  readonly address?: Maybe<Scalars['String']['output']>;
  readonly aspectRatio?: Maybe<Wws_AspectRatio>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly guidance?: Maybe<Wws_PageItemGuidance>;
  readonly id: Scalars['Int']['output'];
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly originalPhoto?: Maybe<Scalars['String']['output']>;
  readonly phone?: Maybe<Scalars['String']['output']>;
  readonly photo?: Maybe<Wws_Photo>;
  readonly photoHeight?: Maybe<Scalars['String']['output']>;
  readonly photoId?: Maybe<Scalars['String']['output']>;
  readonly photoPath?: Maybe<Scalars['String']['output']>;
  readonly photoWidth?: Maybe<Scalars['String']['output']>;
  readonly rank: Scalars['Float']['output'];
  readonly type: Scalars['String']['output'];
  readonly website?: Maybe<Scalars['String']['output']>;
}

export interface Wws_WeddingPartyItem extends Wws_PageItem {
  readonly __typename?: 'WWS_WeddingPartyItem';
  readonly aspectRatio?: Maybe<Wws_AspectRatio>;
  readonly childItems?: Maybe<ReadonlyArray<Wws_PageItem>>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly guidance?: Maybe<Wws_PageItemGuidance>;
  readonly id: Scalars['Int']['output'];
  readonly originalPhoto?: Maybe<Scalars['String']['output']>;
  readonly people?: Maybe<ReadonlyArray<Wws_PageItem>>;
  readonly photoHeight?: Maybe<Scalars['String']['output']>;
  readonly photoId?: Maybe<Scalars['String']['output']>;
  readonly photoPath?: Maybe<Scalars['String']['output']>;
  readonly photoWidth?: Maybe<Scalars['String']['output']>;
  readonly rank: Scalars['Float']['output'];
  readonly title?: Maybe<Scalars['String']['output']>;
  readonly type: Scalars['String']['output'];
}

/** WeddingWebsite objects which you can enjoy */
export type Wws_WeddingWebsiteResult = {
  readonly theme?: Maybe<Wws_Theme>;
  readonly weddingUuid?: Maybe<Scalars['String']['output']>;
};

export interface Wws_WeddingWebsiteV2 extends Wws_WeddingWebsiteResult {
  readonly __typename?: 'WWS_WeddingWebsiteV2';
  readonly announcement?: Maybe<Wws_Announcement>;
  readonly contentItems?: Maybe<ReadonlyArray<Wws_ContentItem>>;
  readonly countdownDays?: Maybe<Scalars['Int']['output']>;
  readonly coverPhoto?: Maybe<Wws_CoverPhoto>;
  readonly coverPhotoPathWithCropbox?: Maybe<Scalars['String']['output']>;
  readonly fianceFirstName?: Maybe<Scalars['String']['output']>;
  readonly fianceLastName?: Maybe<Scalars['String']['output']>;
  readonly firstName?: Maybe<Scalars['String']['output']>;
  readonly hideCountdown?: Maybe<Scalars['Boolean']['output']>;
  readonly hideDate?: Maybe<Scalars['Boolean']['output']>;
  readonly id: Scalars['Int']['output'];
  readonly lastName?: Maybe<Scalars['String']['output']>;
  /** The Layout of the website. Ex \\"multi-page" or "single-page" */
  readonly layout?: Maybe<Scalars['String']['output']>;
  readonly locationContents?: Maybe<ReadonlyArray<Wws_LocationContent>>;
  readonly pages?: Maybe<ReadonlyArray<Wws_Page>>;
  readonly photoAlbums?: Maybe<ReadonlyArray<Wws_PhotoAlbum>>;
  readonly pinProtect?: Maybe<Scalars['Boolean']['output']>;
  readonly purchaseDomain?: Maybe<Wws_PurchaseDomain>;
  readonly registryNote?: Maybe<Scalars['String']['output']>;
  readonly reverseCoupleNameOrder?: Maybe<Scalars['Boolean']['output']>;
  readonly searchEngineIndexable?: Maybe<Scalars['Boolean']['output']>;
  readonly searchable?: Maybe<Scalars['Boolean']['output']>;
  readonly showPublishBanner?: Maybe<Scalars['Boolean']['output']>;
  readonly slug: Scalars['String']['output'];
  readonly stories?: Maybe<ReadonlyArray<Wws_Story>>;
  readonly theme?: Maybe<Wws_Theme>;
  readonly userUuid?: Maybe<Scalars['String']['output']>;
  readonly vanityRoot?: Maybe<Scalars['String']['output']>;
  readonly weddingDateFormat?: Maybe<Scalars['String']['output']>;
  readonly weddingDateRangeEnd?: Maybe<Scalars['WWS_Date']['output']>;
  readonly weddingDateRangeStart?: Maybe<Scalars['WWS_Date']['output']>;
  readonly weddingLocation?: Maybe<Scalars['String']['output']>;
  readonly weddingUuid?: Maybe<Scalars['String']['output']>;
}


export type Wws_WeddingWebsiteV2ThemeArgs = {
  themeId?: InputMaybe<Scalars['String']['input']>;
};

export interface Wedding {
  readonly __typename?: 'Wedding';
  readonly id: Scalars['ID']['output'];
  readonly season?: Maybe<Season>;
  readonly unconfirmedAttributes: ReadonlyArray<Maybe<Scalars['String']['output']>>;
  readonly weddingDate: Scalars['String']['output'];
}

export interface WeddingDatePreferences {
  readonly __typename?: 'WeddingDatePreferences';
  readonly datePreference?: Maybe<DatePreference>;
  readonly hideCountdown?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use datePreference. */
  readonly hideDate?: Maybe<Scalars['Boolean']['output']>;
  readonly season?: Maybe<SeasonName>;
  readonly weddingDate?: Maybe<Scalars['String']['output']>;
  readonly weddingDateFormat?: Maybe<Scalars['String']['output']>;
  readonly weddingDateRangeEnd?: Maybe<Scalars['String']['output']>;
  readonly weddingDateRangeStart?: Maybe<Scalars['String']['output']>;
  readonly weddingEventTime?: Maybe<Scalars['String']['output']>;
  readonly year?: Maybe<Scalars['Int']['output']>;
}
